<template>
    <div class="flex md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div>
        <section class="font-poppins w-screen p-2 md:pl-1 md:pr-1">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE ORDERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>

            <div class="flex mt-4 md:text-sm">
                <div @click="goBack" class="flex cursor-pointer">
                    <i class="fa fa-arrow-left mr-3"></i>
                    <p>Go Back</p>
                </div>
                <div class="flex ml-5 font-bold">
                    <p >Orders List</p>
                    <i class="fa fa-angle-right mt-1 ml-4"></i>
                    <p class="ml-4">Create Order</p>
                </div>
            </div>

            <div class="flex justify-between">
                <div class="mt-8 w-1/3 pb-3 md:w-full md:p-2">
                    <p class="text-sm text-blue-800">Please search Address on Map</p>
                    <form @submit.prevent="showModal">
                        <div class="flex">
                            <div class="flex flex-col">
                                <i class="fa fa-map-marker text-blue-400"></i>
                                <div>
                                    <p>|</p>
                                    <p>|</p>
                                    <p>|</p>
                                </div>  
                                <i class="fa fa-map-marker"></i>
                            </div>
                            <div class="ml-5">
                                <div class="mb-3 border bg-gray-100 p-2 rounded-lg">
                                    {{
                                        place.country != null
                                        ? place.country + ", " + place.address_description
                                        : "Pick Up Location"
                                    }}
                                </div>
                                <div class="mb-3 border bg-gray-100 p-2 rounded-lg">
                                    {{
                                        place2.country != null
                                        ? place2.country + ", " + place2.address_description
                                        : "Delivery Location"
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <p class="text-blue-600">Name and quantity of goods</p>
                            <input class="w-full border bg-gray-100 p-2 rounded-lg mt-2" type="text" name="goods-name" id="goods-name" placeholder="2 bags of rice, 6 puppies">
                        </div>

                        <div class="mt-3">
                            <p class="text-blue-600">Receiver's Details</p>
                            <input class="w-full border bg-gray-100 p-2 rounded-lg mt-2" type="text" name="name" id="name" placeholder="Name"><br>
                            <input class="w-full border bg-gray-100 p-2 rounded-lg mt-2" type="text" name="phone" id="phone" placeholder="Phone">
                        </div>

                        <div class="mt-3">
                            <p class="text-blue-600">Input preferred time and date of pick up</p>
                            <div class="flex">
                                <input class="w-full border bg-gray-100 p-2 rounded-lg mt-2" type="date" name="date" id="date" placeholder="Date"><br>
                                <input class="w-full ml-2 border bg-gray-100 p-2 rounded-lg mt-2" type="time" name="time" id="time" placeholder="Time">
                            </div>
                            
                        </div>

                        <textarea name="describe" id="describe" rows="6"  class="w-full bg-gray-100 rounded-lg p-1 text-sm mt-3">Enter Description</textarea>

                        <div class="mt-3">
                            <p class="font-semibold">Delivery Cost</p>
                            <p>Here is the cost of your Delivery</p>
                        </div>

                        <div class="mt-3">
                            <i class="fa fa-cab"></i>
                            <p class="font-bold">NGN10,520</p>
                        </div>
                        <div class="mt-4">
                            <button class=" w-1/2 bg-blue-700 p-2 text-white rounded-lg">Confirm</button>
                        </div>
                       
                    </form>
                </div>

                <div class="w-1/2 mt-8">
                    
                    <place-search
                    v-bind:ready="ready"
                    loading="Map is loading"
                    v-bind:gps_timeout="7000"
                    v-bind:fallbackProcedure="fallbackProcedure"
                    v-bind:zoom="zoom"
                    v-bind:geolocation="geolocation"
                    v-bind:address="address"
                    v-bind:manually="manually"
                    @changed="getMapData"
                    >
                    </place-search>

                    <place-search
                    v-bind:gps_timeout="7000"
                    v-bind:fallbackProcedure="fallbackProcedure"
                    v-bind:zoom="zoom"
                    v-bind:geolocation="geolocation"
                    v-bind:address="address"
                    v-bind:manually="manually"
                    @changed="getMapData2"
                    >
                    </place-search>
                </div>
            </div>
            
            

            <!-- <div>
                <Modal
                v-show="isModalVisible"
                @close="closeModal"
                />
            </div> -->
        </section>
    </div>
</template>

<script>
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
// import {baseUrl} from '../../../Config';
// const url = baseUrl;
// import Modal from './Modal.vue';
import PlaceSearch from './PlaceSearch.vue';
export default {
    components: {
        Notification,
        AdminDashboardNav,
        GetDate,
        // Modal,
        PlaceSearch,
    },
    data() {
        return {
            ready: false, //Add ready:false to stop map from loading, and then when changed to true map will auto load
            fallbackProcedure: "gps", //gps | geolocation | address | manually
            zoom: 17, //Default Zoom
            geolocation: {
        // If GPS and Find by address fails then, map will be positioned by a default geolocation
            lat: 9.6542801,
            lng: 7.3987169,
            zoom: 2,
            },
            address: {
                query: "Nigeria", //If GPS fails, Find by address is triggered
                zoom: 10,
            },
            manually: {
                address_description: "Nigeria",
                city: "Nigeria",
                country: "Nigeria",
                lat: 9.6542801,
                lng: 7.3987169,
                state: "Nigeria",
                zip_code: "",
                zoom: 17,
            },
            place: {},
            place2: {},
            form_data: {},
        }

    },

    mounted() {
        this.triggerReady();
    },
    

     methods: {
         goBack() {
            this.$router.go(-1);
         },
        getMapData(place) {
            this.place = place;
            console.log("place", place);
            },
        triggerReady() {
            this.fallbackProcedure = "manually";
            this.ready = true;
        },
        getMapData2(place) {
            this.place2 = place;
            console.log("place2",place);
            
        },
        getMapData3(place) {
            this.place2 = place;
            console.log("place2",place);
            
        },
     }
    
}
</script>